import { ITransactionHistoryTableRowDetails } from '@funds/components/TransactionHistoryTable/components/TransactionHistoryTableRow/ITransactionHistoryTableRow';

export interface IOldTransaction {
  created_at: string;
  currency: string;
  type: keyof typeof TransactionTypes;
  in: null | string;
  out: null | string;
  payment_id: null | number;
  transaction_id: number;
  balance?: number;
}
export default interface ITransaction {
  created_at: string;
  currency: string;
  type: keyof typeof TransactionTypes;
  in: null | string;
  out: null | string;
  details: ITransactionHistoryTableRowDetails;
  payment_id: null | number;
  transaction_id: number;
  balance?: number;
}

export const TransactionTypes: { [key: string]: string } = {
  Back: 'Back',
  Blocked: 'Pending Transaction/Order',
  BonusExpiration: 'Bouns Expiration',
  BonusInvestment: 'Bonus Investment',
  BuyShare: 'Buy Share',
  CashReturn: 'Cash Return',
  Deposit: 'Deposit',
  DirectDividend: 'DirectDividend',
  Dividend: 'Dividend',
  DividendFee: 'Fee',
  ExitFee: 'Fee',
  ExitProceed: 'Investment Exit Proceed',
  ExternalFee: 'External Fee',
  Fee: 'Fee',
  FeeTransaction: 'Fee',
  FeeRequest: 'Fee Request',
  FreeDeposit: 'Deposit',
  Investment: 'Investment',
  MangopayFee: 'Mangopay Fee',
  MangopayPayout: 'Mangopay Payout',
  MembershipUpgrade: 'Membership Upgrade',
  Remittance: 'Remittance',
  SellShare: 'Share Sale',
  EthStakingDeposit: 'Staking Deposit',
  StakingReward: 'Staking Reward',
  StakingFee: 'Staking Fee',
  EthStakingTransfer: 'Staking Withdraw',
  Unblocked: 'Funds Released',
  Withdraw: 'Withdrawal',
  RewardDeposit: 'Reward',
  InternalTransaction: 'Token Purchase Payment', // TODO: Remove with FF ENABLE_BINANCE_TRADING
  OutcomeTransaction: 'Outcome Transaction',
  IncomeTransaction: 'Income Transaction',
  TokenPurchase: 'Token Purchase',
  'PublicEquityShares::Blocked': 'Pending Request to Sell order',
  'PublicEquityShares::Deposit': 'Public Equity Deposit',
  'PublicEquityShares::Fee::Sell': 'Public Share Sale Fee',
  'PublicEquityShares::Fee::Share': 'Fractional Share Sale Fee',
  'PublicEquityShares::Proceed': 'Proceeds distribution from Public Share Sale',
  'PublicEquityShares::Sell': 'Public Equity Sale',
  'PublicEquityShares::Unblocked': 'Request Completed - Shares No Longer on Hold'
};

export const TransactionTypesDescriptions: { [key: string]: string } = {
  Back: 'Back',
  Blocked: 'These funds are unavailable, it may be due to a pending withdrawal or an open order',
  BonusExpiration: 'The bonus balance has expired',
  BonusInvestment: 'Bonus balance associated with a pitch investment',
  BuyShare: 'Buy transaction on the Secondary Market',
  CashReturn: 'Cash return',
  Deposit: 'Deposit of funds to BF Funds',
  DirectDividend: 'Direct dividend',
  Dividend: 'Dividend proceeds from shares held in a platform investment',
  DividendFee: 'Dividend fee',
  ExitFee: 'Investment exit fee (5%)',
  ExitProceed: 'Investment exit proceed',
  ExternalFee: 'External fee',
  Fee: 'External fee',
  FeeTransaction: 'Fee',
  FeeRequest: 'Unsettled fee',
  FreeDeposit: 'Special deposit by BF Team',
  Investment: 'Pitch investment on the platform',
  MangopayFee: 'Mangopay fee',
  MangopayPayout: 'Mangopay payout',
  MembershipUpgrade: 'Upgrade to VIP membership',
  Remittance: 'Remittance',
  SellShare: 'Sell transaction on the Secondary Market',
  StakingFee: 'Staking Fee',
  StakingReward: 'Staking Reward',
  Unblocked: 'These funds have been released',
  Withdraw: 'Withdrawal of funds out of BF Funds',
  RewardDeposit: 'Funds received from BF loyalty rewards program',
  InternalTransaction: 'Payment for Token Purchase', // TODO: Remove with FF ENABLE_BINANCE_TRADING
  OutcomeTransaction: 'Outcome Transaction',
  IncomeTransaction: 'Income Transaction',
  TokenPurchase: 'Funds received from Token Purchase',
  'PublicEquityShares::Blocked': 'Your shares are currently on hold whilst we are processing your request to sell your public shares',
  'PublicEquityShares::Deposit': 'Private shares of <company> have been converted into public shares and distributed into your BF Account.',
  'PublicEquityShares::Fee::Sell': 'Flat Fee in USD for selling your Public Shares',
  'PublicEquityShares::Fee::Share': 'The order execution is rounded down to the nearest whole number as fraction share sales are not supported by the stock exchange, with any fractional share being charged as a fee',
  'PublicEquityShares::Proceed': 'Your shares have been sold and the corresponding proceeds have been deposited into the funds section of your account',
  'PublicEquityShares::Sell': 'Your request to sell your public shares has been processed and the proceeds have been deposited into the funds section of your account',
  'PublicEquityShares::Unblocked': 'Your request to sell your public shares has been processed. The shares are no longer on hold. For more details on the outcome, whether completed or canceled, please refer to the next transaction update'
};
